import { Component, Input } from '@angular/core'

import { AuthService } from '../../services/auth.service'
import { TableOrderService } from '../../services/tableOrder.service'

import { User } from '../../interfaces/IUserData'
import { LiveMenuTableOrder, PaymentHistory } from '../../interfaces/livemenu-table-order.interface'

@Component({
	selector: 'app-order-summary',
	templateUrl: './order-summary.component.html',
	styleUrls: ['./order-summary.component.scss'],
})
export class OrderSummaryComponent {
	@Input() valuePaid: string = '0'

	tableOrder: LiveMenuTableOrder
	myOrdersValueAcceptedOrPaid: number = 0
	myOrdersValuePaid: number = 0
	user: User
	lastPaymentFromUser: PaymentHistory

	constructor(public tableOrderService: TableOrderService, private authService: AuthService) {
		this.tableOrderService.tableOrder$.subscribe(store => {
			this.tableOrder = store.table
			
			this.myOrdersValueAcceptedOrPaid = this.tableOrderService.calcMyOrdersValueAccepted()
			this.myOrdersValuePaid = tableOrderService.calcMyOrdersValuePaid()

			this.lastPaymentFromUser = store.table.paymentHistory.reduce((order, orderb) =>
				new Date(order.date) > new Date(orderb.date) ? order : orderb
			)
		})

		this.authService.currentUser$.subscribe(userStore => {
			this.user = userStore?.user
		})
	}

	paidTotal() {
		return this.tableOrder.remainingOrdersPrice <= 0
	}

	calcPercentage(ordersPriceSum: number, remainingOrdersPrice: number): number {
		if (ordersPriceSum === 0) {
			return 0
		}
		
		return Math.round((remainingOrdersPrice * 100) / ordersPriceSum)
	}

	get getPaymentExtra() {
		return Math.abs(this.tableOrder.remainingOrdersPrice)
	}
}
